import axios from "axios";

export const REACT_APP_LENTRA_TOKEN_BASE_URL = process.env.REACT_APP_LENTRA_TOKEN_BASE_URL;
export const REACT_APP_LENTRA_LEAD_BASE_URL = process.env.REACT_APP_LENTRA_LEAD_BASE_URL;
export const REACT_APP_LENTRA_CLIENT_IDENTIFIER = process.env.REACT_APP_LENTRA_CLIENT_IDENTIFIER;
export const REACT_APP_LENTRA_CLIENT_SECRET = process.env.REACT_APP_LENTRA_CLIENT_SECRET;
export const REACT_APP_LENTRA_INSTITUTION_NAME = process.env.REACT_APP_LENTRA_INSTITUTION_NAME;
export const REACT_APP_LENTRA_TENANT_ID = process.env.REACT_APP_LENTRA_TENANT_ID;

export const LENTRA_JWT_TOKEN = localStorage.getItem("lentra_jwt_token");
export const LENTRA_ACCESS_TOKEN = localStorage.getItem("lentra_access_token");
export const LENTRA_INSTITUTION_ID = localStorage.getItem("lentra_institutionId");

export async function callApiLentra(req, delayMs = 0, header = {}, tokenType = "jwt") {
  const { url, method = "POST", data = {} } = req;

  const token = tokenType === "jwt" ? LENTRA_JWT_TOKEN : LENTRA_ACCESS_TOKEN;

  const headers = {
    "Content-Type": "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
    ...header,
  };

  try {
    const res = await axios({
      url: REACT_APP_LENTRA_TOKEN_BASE_URL + url,
      method: method,
      data: data,
      headers,
    });

    // delay after getting response
    if (delayMs > 0) await new Promise((res) => setTimeout(res, delayMs));

    return res.data;
  } catch (error) {
    console.error("API Error:", error);
    window.location.href = "/lentra-error";
    throw error;
  }
}
